export default {
  example: {
    test: '語言測試'
  }
}